// import OnlinePayment from '@/components/views/OnlinePayment';
import React, { useEffect } from 'react';
import PopupBox from './PopUpSmall';

const GlobalDialog = (): JSX.Element => {
    const [open, setOpen] = React.useState(false);
    const [dialogId, setDialogId] = React.useState(null);
 
    useEffect(() => {
        document.addEventListener('click', (e) => {
            const target = e.target as HTMLTextAreaElement;
            const openDialog = target.classList.contains('open-dialog');
            if (openDialog) {
                handlePopupClick(e);
            }
        });
    }, []);

    const handlePopupClick = (e) => {
        const element = e.target;
        const dialogId = element.getAttribute('data-dialog-id');
       
        setDialogId(dialogId);
        setOpen(true);
    };
   

    return (
        <>
         
           <PopupBox
                dialogId={dialogId}
                open={open}
                onClose={() => setOpen(false)}
            /> 

            {/* <OnlinePayment
                open={makePayment}
                onClose={() => setMakePayment(false)}
            /> */}
        </>
    );
};

export default GlobalDialog;
